import { UpdateFieldsInGroupParams } from '@uturn/api/v2';
import { Dialog, DialogContent } from '@uturn/ui-kit';
import { useRef, useState } from 'react';
import { MultiUpdateForm } from './multi-update-form';
import { MultiUpdateUnsavedChangesDialog } from './multi-update-unsaved-changes-dialog';

export type UpdateFilters = Partial<Omit<UpdateFieldsInGroupParams, 'status'>>;

type Props = {
	openModal: boolean;
	setOpenModal: (open: boolean) => void;
	exportFilters: UpdateFilters;
	preselectPublish?: boolean;
};

export const MultiUpdateModal = ({
	openModal,
	setOpenModal,
	exportFilters,
	preselectPublish = false,
}: Props) => {
	const isDirtyRef = useRef(false);
	const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);
	const dialogRef = useRef<HTMLDivElement | null>(null);

	const handleClose = () => {
		if (isDirtyRef.current) {
			setShowUnsavedDialog(true);
		} else {
			setOpenModal(false);
		}
	};

	const confirmClose = () => {
		setShowUnsavedDialog(false);
		setOpenModal(false);
	};

	return (
		<>
			<Dialog open={openModal} onOpenChange={handleClose}>
				<DialogContent
					className="md:w-[70vw] md:max-w-[70vw] focus-visible:outline-none box-shadow-none"
					ref={dialogRef}
					id="multi-update-dialog-content"
				>
					<MultiUpdateForm
						setOpenModal={setOpenModal}
						isDirtyRef={isDirtyRef}
						exportFilters={exportFilters}
						preselectPublish={preselectPublish}
					/>
				</DialogContent>
			</Dialog>
			<MultiUpdateUnsavedChangesDialog
				open={showUnsavedDialog}
				onCancel={() => setShowUnsavedDialog(false)}
				onConfirm={confirmClose}
			/>
		</>
	);
};
